import { components } from "@certn/api/generated-schemas/applicant-portal";
import { StepType } from "@certn/cascadia-react/components/stepper/ActivityStepper";
import { formatDate } from "@certn/utils";
import { useTranslation } from "react-i18next";

import { BaseCard } from "./BaseCard";

interface Props {
  caseInstance: components["schemas"]["CompleteCaseList"];
}

export function DisputeCard(props: Props) {
  const { caseInstance } = props;
  const { t } = useTranslation();

  const disputedDate = caseInstance.logs?.findLast(
    ({ additional_data }) => additional_data?.event === "CHECK_DISPUTED"
  )?.timestamp;

  const progressSteps: StepType[] = [];

  const lastIndex = caseInstance.logs?.length && caseInstance.logs.length - 1;
  caseInstance.logs?.forEach(({ additional_data, timestamp }, index) => {
    if (additional_data?.event === "APPLICANT_SUBMITTED") {
      progressSteps.push({
        title: t("Submitted"),
        description:
          t("You submitted the application to Certn on ") +
          formatDate(timestamp, "PPP"),
        status: "COMPLETE",
      });
      progressSteps.push({
        title: t("Processing"),
        description:
          lastIndex === index
            ? t("Certn is currently processing the report")
            : t("Certn sent the report to ") + caseInstance.customer_name,
        status: lastIndex === index ? "INCOMPLETE" : "COMPLETE",
      });
    }

    if (additional_data?.event === "CHECK_DISPUTED") {
      progressSteps.push({
        title: t("In dispute"),
        description:
          lastIndex === index
            ? t("Certn is currently processing the report dispute")
            : t("Completed") + " " + formatDate(timestamp, "PPP"),
        status: lastIndex === index ? "INCOMPLETE" : "COMPLETE",
      });
    }
  });

  progressSteps.push({
    title: t("Complete"),
    description: "",
    status: "INCOMPLETE",
  });

  return (
    <BaseCard
      title={caseInstance.customer_name}
      type="dispute"
      tagText={t("In dispute")}
      statusText={`${t("Submitted")} ${formatDate(disputedDate ?? "", "PP")}`}
      progressSteps={progressSteps}
      variant="historyCard"
      shortID={caseInstance.short_id}
    />
  );
}
